"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _axios = _interopRequireDefault(require("axios"));

require("./SearchAutopilot.scss");

var _theLoopsService = require("../../../services/theLoopsService");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchAutoPilot = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(SearchAutoPilot, _PureComponent);

  var _super = _createSuper(SearchAutoPilot);

  function SearchAutoPilot() {
    var _this;

    (0, _classCallCheck2.default)(this, SearchAutoPilot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tokenRefreshTimer", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMessageReceived", function (e) {
      var _e$detail = e.detail,
          type = _e$detail.type,
          data = _e$detail.data;
      var query = type === 'ask-invoked' ? data : data === null || data === void 0 ? void 0 : data.item;

      if (query && (type === 'ask-invoked' || type === 'search-result-item-clicked')) {
        _this.navigateToAutopilot(query);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initializeWidget", function (widgetId, tenantId, cssVariablesContent, userData) {
      var _window$widgets, _window$preAsk;

      window.widgets = (_window$widgets = window.widgets) !== null && _window$widgets !== void 0 ? _window$widgets : {};
      window.widgets.generateUserToken = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (0, _theLoopsService.refreshTheLoopsToken)({
                  widgetId: widgetId,
                  userId: userData.userId
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      loopsGlobal.setLoopsAskWidgetConfig({
        tenantId: tenantId,
        userId: userData.userId,
        userEmail: userData.userEmail,
        widgetId: widgetId,
        widgetWidth: '100%',
        widgetHeight: '100%',
        widgetRenderingId: 'tlw-container-wrapper',
        data: {
          widgetType: 'ask',
          styleSheets: ["".concat(_this.props.cdnPrefix).concat(_this.props.cdnPrefix.endsWith('/') ? '' : '/', "css/autopilot-widget.css")],
          styles: cssVariablesContent + _this.props.customCss + ".welcome-container { display: none !important; } #tlw-widget { background-color: transparent !important; border: none !important; } .card-text { white-space: nowrap !important; overflow: hidden !important; text-overflow: ellipsis !important; } .card { height: 42px !important; }",
          suggestedQueries: 'external'
        },
        callbacks: {
          preAsk: (_window$preAsk = window.preAsk) !== null && _window$preAsk !== void 0 ? _window$preAsk : function () {}
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "navigateToAutopilot", function (query) {
      window.location.href = _resolveUrl((0, _absoluteUrlRuntime.resolveUrl)("/autopilot?query=".concat(encodeURIComponent(query))));
    });
    return _this;
  }

  (0, _createClass2.default)(SearchAutoPilot, [{
    key: "render",
    value: // eslint-disable-next-line class-methods-use-this
    function render() {
      return (0, _preact.h)("div", {
        id: "tlw-container-wrapper"
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _document$getElementB,
          _document$getElementB2,
          _this2 = this;

      // The Loops (vendor) requires this callback function to be present globally
      window.preAsk = function (_ref2) {
        var searchKeyword = _ref2.searchKeyword;
        window.location.href = (0, _absoluteUrlRuntime.resolveUrl)("/autopilot?query=".concat(encodeURIComponent(searchKeyword)));
      };

      var cssVariablesContent = (_document$getElementB = (_document$getElementB2 = document.getElementById('css-variables')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.textContent) !== null && _document$getElementB !== void 0 ? _document$getElementB : ''; // Get community configuration from API and configure the widget

      _axios.default.get('/theloops/details').then(function (response) {
        var data = response.data.data;
        var widgetId = data.widget_id,
            tenantId = data.loops_tenant_id; // Configure the Loops widget with the JWE token

        var userData = (0, _theLoopsService.getTheLoopsUserData)();

        _this2.initializeWidget(widgetId, tenantId, cssVariablesContent, userData);
      }).catch(function (error) {
        console.error('TheLoops API Error:', error);
      });

      window.addEventListener('onLoopsMessageReceived', this.handleMessageReceived);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('onLoopsMessageReceived', this.handleMessageReceived);
    }
  }]);
  return SearchAutoPilot;
}(_preactCompat.PureComponent);

exports.default = SearchAutoPilot;